import React from 'react';
import phoneFormat from 'helpers/phoneFormat';
import moment from 'moment';
import {dateTimeFormats} from 'helpers/constants';

export function formatEmails(report, formatMessage) {
  if (!report.Email || report.Email.trim() === '') {
    return <div><i className='bl bl-attention red' /> {formatMessage('general.no.email')}</div>;
  }

  if (report.PastDue === false) {
    return <div><i className='bl bl-opted-out'/> {formatMessage('general.email.opted.out')}</div>;
  }

  if (report.PastDueNotify === true) {
    return <div>{formatMessage('general.email.sent')}</div>;
  }

  return <div><i className='bl bl-attention red' /> {formatMessage('general.email.not.sent')}</div>;
}

export function formatReport(report = [], formatMessage) {
  return report.map(_row => {
    let row = Object.assign({}, _row);

    row.FullName = row.NameFirst + ' ' + row.NameLast;
    row.HomePhone = row.HomePhone ? phoneFormat(row.HomePhone) : '';
    if (!row.Email || row.Email.trim() === '') {
      row.EmailString = formatMessage('general.no.email');
    } else if (row.PastDue === false) {
      row.EmailString = formatMessage('general.email.opted.out');
    } else if (row.PastDueNotify === true) {
      row.EmailString = formatMessage('general.email.sent');
    } else {
      row.EmailString = formatMessage('general.email.not.sent');
    }
    if (row.NextAnalysisDate) {
      row.NextAnalysisDate = moment(row.NextAnalysisDate).format(dateTimeFormats.numeralDate);
    }
    if (row.PrevAnalysisDate) {
      row.PrevAnalysisDate = moment(row.PrevAnalysisDate).format(dateTimeFormats.numeralDate);
    }
    return row;
  });
}
